// extracted by mini-css-extract-plugin
export default {"wrapper":"inviteModal_wrapper__Q0apF","blankWrapper":"inviteModal_blankWrapper__FGmtG","contentWrapper":"inviteModal_contentWrapper__4Q--3","footer":"inviteModal_footer__YNQcF"};